export default __webpack_public_path__ + "static/4fa6cd2f6f7bf4f081a52f2381d656bf.ttf";